import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { BasicModalComponent } from '../modules/shared/components/basic-modal/basic-modal.component';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private readonly _dialog: MatDialog) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error('Unauthorized Access:', error);
          this._dialog.open(BasicModalComponent, {
            data: {
              title: 'Sessione Scaduta',
              text: 'Chiudi questa finestra e riaprine una nuova per continuare ad operare.',
              modalSize: 'modal-box-small text-center vertical-align',
            },
            disableClose: true,
          });
        }
        return throwError(() => error);
      })
    );
  }
}
